import React from "react";
import { images } from "../../constants";
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrap";
import "./Footer.scss";

const Footer = () => {
  return (
    <div>
      <h2 className="head-text">Contacts</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href={`mailto:${process.env.REACT_APP_EMAIL}`} className="p-text">
            {process.env.REACT_APP_EMAIL}
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href={`tel:${process.env.REACT_APP_PHONE}`} className="p-text">
            {process.env.REACT_APP_PHONE}
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.resume} alt="resume" />
          <a
            href={process.env.REACT_APP_RESUME}
            className="p-text"
            target="_blank"
            rel="noreferrer"
          >
            Resume
          </a>
        </div>

        <div className="app__footer-card app__footer-card-social-media">
          <img src={images.linkedin} alt="linkedin" />
          <a
            href={process.env.REACT_APP_LINKEDIN}
            className="p-text"
            target="_blank"
            rel="noreferrer"
          >
            Linkedin
          </a>
        </div>
        <div className="app__footer-card app__footer-card-social-media">
          <img src={images.twitter} alt="twitter" />
          <a
            href={process.env.REACT_APP_TWITTER}
            className="p-text"
            target="_blank"
            rel="noreferrer"
          >
            Twitter
          </a>
        </div>
        <div className="app__footer-card app__footer-card-social-media">
          <img src={images.github} alt="github" />
          <a
            href={process.env.REACT_APP_GITHUB}
            className="p-text"
            target="_blank"
            rel="noreferrer"
          >
            Github
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__whitebg"
);
